import styled from "styled-components";
import { CrossmintPayButton } from "@crossmint/client-sdk-react-ui";

const Container = styled("div")`
    width: 100vw;
    height: auto;
    background-color: #acd1d5;
    
    margin-top: 10px;
    padding: 200px 10;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
const Retainer = styled("div")`
    width: 100vw;
    height: 180px;
    background-color: #55beca;

    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    position: relative;

`
const Texto =styled("h2")`
    padding: 20px 10px 5px 5px;
    align-items: center;
    justify-content: center;
    margin-left: 30px;
    margin-right: 30px;
`

const Membresia = () => {
    return (
        <Container>
            <CrossmintPayButton
                clientId="9bd726fc-fb4e-4745-8172-2c65169d322e"
                mintConfig={{"type":"candy-machine"}}
            />
             <h1 style={{}}></h1>
             <h1 style={{}}></h1>
            <h1 style={{}}>Membresias</h1>
            <Texto>
            Esta plataforma ha sido desarrollada con el objetivo de crear una comunidad de parsonas que no solo quiera generar ingresos pasivos, sino que ademas este dispuesta a asumir los retos y riesgos para tener ingresos activos y un portafolio solido de inversiones en medios digitales. Nuestro sistema de Categorias te permite ir obteniendo beneficios adicionales por tu participación y contribución activa dentro del club, nuestro proposito no es unicamente entregarte el pescado, sino tambien enseñarte a pescar, en base a esto a medida que tu presencia y crecimiento se vaya fortaleciendo, tu NFT ira ascendiendo o descendiendo de categoria con nuestro sistema de membresias, esto se vera reflejado en la metadata del NFT en el atributo Membresia. Trimestralmente segun tu desempeño este atributo será actualizado en el NFT y en base a esa categoria obtendras los beneficios asociados para el siguiente trimestre. Para que tu membresia ascienda o evitar que tu membresia descienda debes pagar una compensación en nuestra crypto nativa conforme al nivel actual, estos valores serán publicados en nuestro sitio web principal.
            </Texto>
            <h1 style={{color:"blue"}}>Membresia Regular</h1>
            <Texto style={{color:"blue"}}>
            Esta membresia te abre la puerta al conocimiento que necesitas tener para generar ingresos en todo tipo de pletaformas digitales, con ella tendras acceso a capacitaciones y cursos en Tecnologia Blockchain, Mercados de Acciones, Mercados Crypto, Comercio en Exchanges centralizados, Finanzas Decentralizadas o DeFi, Creación y Comercio de NFTs, Marketing digital en redes, Diseño y programación web. Con la membresia regular tendras acceso a la mayoria de nuestros eventos y rondas de inversion, recibiras analisis tecnico y fundamental de  los mercados, señales de inversión y las tendencias que primarán en los mercados, te actualizaremos con las noticias que pueden afectar los mercados de forma positiva o negativamente. Tendras accceso a los eventos principales organizados por nosotros y a sorteos semanales, mensuales y trimestrales. Con la membresia del club obtendras nuestra crypto nativa, la cual obtendras diariamente por mantener tu NFT en Stake y con ella podras ascender de nivel más rapidamente y acceder a mas beneficios. 
            </Texto>
            <h1 style={{color:"grey"}}>Membresia Silver</h1>
            <Texto style={{color:"grey"}}>
            La membresia Silver te brinda todos los beneficios de la membresia Regular y ademas te permite acceder a programas de fortalecimiento empresarial, tendras acompañamiento para mejorar tus ideas de emprendimiento y llevarlas a cabo o potenciarlas si ya las has implementado. Tendrás una consulta bimestral personalizada con expertos en mercadeo digital, finanzas y asesoria fiscal, tambien tendras el espacio para que tus productos y servicios seán dados a conocer dentro de toda la comunidad del CLub de Inversionistas. Al estar en este nivel recibes 1,25 veces nuestra crypto nativa y 0,25% diario de ingreso pasivo pagado mensualmente en Ethereum o Solana
            </Texto >
            <h1 style={{color:"#d4af37"}}>Membresia Gold</h1>
            <Texto style={{color:"#d4af37"}}>
            La membresia Gold cuenta con todos los beneficios de la membresia Silver. Con ella tendrás derecho a una consulta mensual personalizada con nuestros expertos y el equipo desarrollador del club de inversiones. En la membresia Gold tendras la posibilidad de ganar sorteos mensuales exclusivos para vivir experiencias inolvidables con tu familia o amigos. Al estar en este nivel recibes 1,75 veces nuestra crypto nativa y 0,5% diario de ingreso pasivo pagado mensualmente en Ethereum o Solana
            </Texto>
            <h1 style={{}}>Membresia Black</h1>
            <Texto>
            Todos los beneficios de nuestro club al alcance, la membresia black esta diseñada para que adquieras todo lo que te has propuesto, Consultas semanales, grupos privados, rondas de inversión exclusivas, acceso temprano al desarrollo de nuevos productos y servicios, coaching financiero y diseñaremos para ti el website para tu negocio o marca personal, pagaras por servicios personalizados con nuestra crypto nativa. En este nivel recibes 2,5 veces nuestra crypto y 1,25% de ingreso pasivo pagado quincenalmente en Ethereum o Solana 
            </Texto>
            
            <Retainer>
                <h1>
                    Bienvenido al Club!!!
                </h1>    
            
            </Retainer>
        </Container>
                    
    )
}
export default Membresia;